import React, { useEffect, useMemo, useState } from 'react';
import teamMembersStatic from '../data/teamMembersStatic';
import { adaptStaff, flattenStatic } from '../data/adaptStaff';

const STATIC_FALLBACK = flattenStatic(teamMembersStatic);

const TeamSection = () => {
  const [members, setMembers] = useState(null);

  useEffect(() => {
    let cancelled = false;
    // cache: 'no-store' fuerza al navegador a saltarse la disk cache y revalidar
    // contra el edge en cada carga. El edge sigue cacheando 5 min (s-maxage=300
    // en functions/api/directory.js) así que el coste es despreciable. Sin esto,
    // Cloudflare reescribe nuestro max-age=300 a max-age=2678400 (31 días) en la
    // respuesta al browser, y los usuarios se comen datos viejos durante un mes.
    fetch('/api/directory', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => {
        if (cancelled) return;
        const adapted = adaptStaff(data);
        setMembers(adapted.length > 0 ? adapted : STATIC_FALLBACK);
      })
      .catch((err) => {
        console.error('Directory fetch failed, using static fallback:', err);
        if (!cancelled) setMembers(STATIC_FALLBACK);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const isLoading = members === null;
  const displayedMembers = useMemo(() => members ?? [], [members]);

  return (
    <section className="prt-row team-section01 clearfix">
      <div className="container">
        {/* Existing header content */}
        <div className="row">
          <div className="col-xl-12">
            <div className="tm-scrollintetx-wrapper team-scroll Fristss">
              <div className="big-title"> El Equipo! MAG </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12">
            <div className="desc-text text-end">
              <p>
                Nos esforzamos al máximo para construir un futuro mejor y más saludable para las personas. Nuestro equipo está unido en un compromiso compartido de lograr una mejor salud para todos, en todas partes. Nuestro objetivo principal es mejorar los hábitos alimenticios saludables.
              </p>
            </div>
          </div>
          <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12">
            <div className="section-title text-end">
              <div className="title-header">
                <h2 className="title">
                  <span className="title-heading-underline">los pasos</span> para que tomes el control.
                </h2>
              </div>
            </div>
          </div>
        </div>

        {/* Team Members Grid */}
        <div className="row" style={{ marginTop: '40px' }}>
          {isLoading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={`skel-${i}`} className="col-lg-4 col-md-6 col-sm-12" style={{ marginBottom: '30px' }}>
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    opacity: 0.6
                  }}>
                    <div style={{ width: '100%', height: '450px', backgroundColor: '#f0f0f0' }} />
                    <div style={{ padding: '20px' }}>
                      <div style={{ height: '20px', width: '60%', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '12px' }} />
                      <div style={{ height: '12px', width: '40%', backgroundColor: '#f5f5f5', borderRadius: '4px', marginBottom: '18px' }} />
                      <div style={{ height: '12px', width: '90%', backgroundColor: '#f5f5f5', borderRadius: '4px', marginBottom: '6px' }} />
                      <div style={{ height: '12px', width: '80%', backgroundColor: '#f5f5f5', borderRadius: '4px' }} />
                    </div>
                  </div>
                </div>
              ))
            : displayedMembers.map((member) => (
            <div key={member.id} className="col-lg-4 col-md-6 col-sm-12" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(87,170,70,0.2)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                {/* Image or placeholder */}
                <div style={{
                  width: '100%',
                  height: '450px',
                  position: 'relative',
                  overflow: 'hidden',
                  backgroundColor: '#f5f5f5'
                }}>
                  {member.photoUrl ? (
                    <img
                      src={member.photoUrl}
                      alt={member.name}
                      loading="lazy"
                      decoding="async"
                      width="900"
                      height="1125"
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center top',
                        transition: 'transform 0.4s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                  ) : (
                    <div style={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <svg width="120" height="120" viewBox="0 0 24 24" fill="#ccc" aria-hidden="true">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                      </svg>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div style={{
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1
                }}>
                  {/* Name */}
                  <h3 style={{
                    margin: '0 0 8px 0',
                    fontSize: '1.4rem',
                    fontWeight: '700',
                    color: '#333',
                    lineHeight: '1.3'
                  }}>
                    {member.name}
                  </h3>

                  {/* Job title */}
                  {member.jobTitle && (
                    <div style={{
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      color: '#57aa46',
                      marginBottom: '12px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      {member.jobTitle}
                    </div>
                  )}

                  {/* Bio */}
                  {member.bio && (
                    <p style={{
                      fontSize: '0.85rem',
                      color: '#555',
                      fontStyle: 'italic',
                      margin: '0 0 14px 0',
                      lineHeight: '1.5'
                    }}>
                      {member.bio}
                    </p>
                  )}

                  {/* Function chips */}
                  {member.functions && member.functions.length > 0 && (
                    <div style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '6px',
                      marginBottom: '14px'
                    }}>
                      {member.functions.map((fn, i) => (
                        <span key={i} style={{
                          display: 'inline-block',
                          padding: '5px 12px',
                          fontSize: '0.7rem',
                          fontWeight: '600',
                          borderRadius: '4px',
                          backgroundColor: 'rgba(87, 170, 70, 0.1)',
                          color: '#57aa46',
                          whiteSpace: 'nowrap'
                        }}>
                          {fn}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Divider */}
                  <div style={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: '#e8e8e8',
                    margin: '12px 0'
                  }}></div>

                  {/* Credentials */}
                  {member.credentials && member.credentials.length > 0 && (
                    <div style={{
                      fontSize: '0.8rem',
                      lineHeight: '1.6',
                      color: '#666',
                      marginBottom: '14px',
                      flex: 1
                    }}>
                      {member.credentials.map((item, i) => (
                        <div key={i} style={{ marginBottom: '4px' }}>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Footer: locations + website link, anchored to bottom */}
                  {((member.locations && member.locations.length > 0) || member.websiteUrl) && (
                    <div style={{ marginTop: 'auto' }}>
                      {member.locations && member.locations.length > 0 && (
                        <div style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '6px',
                          marginBottom: member.websiteUrl ? '12px' : '0'
                        }}>
                          {member.locations.map((loc, i) => (
                            <span key={i} style={{
                              fontSize: '0.7rem',
                              color: '#57aa46',
                              padding: '5px 10px',
                              backgroundColor: 'rgba(87, 170, 70, 0.08)',
                              border: '1px solid rgba(87, 170, 70, 0.2)',
                              borderRadius: '12px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '5px',
                              fontWeight: '500',
                              lineHeight: '1.3'
                            }}>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                              </svg>
                              {loc.label}
                            </span>
                          ))}
                        </div>
                      )}
                      {member.websiteUrl && (
                        <a
                          href={member.websiteUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: '0.8rem',
                            color: '#57aa46',
                            textDecoration: 'none',
                            fontWeight: '600',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            paddingTop: '12px',
                            borderTop: '1px solid #e8e8e8',
                            width: '100%'
                          }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                          </svg>
                          Página web
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
